<template>
  <div class="content">
    <div class="form-field">
      <popup-button button-text="Добавить договор">
        <add-document v-bind:plot="id" v-on:document-add="getPlotData"></add-document>
      </popup-button>
    </div>
    <div class="form-field">
      <popup-button button-text="Добавить соглашение">
        <add-agreement v-bind:plot="id" v-on:agreement-add="getPlotData"></add-agreement>
      </popup-button>
    </div>
    <table class="table-container">
      <tr class="table-header">
        <th>Номер</th>
        <th>Дата</th>
        <th>Название</th>
        <th>Услуги</th>
        <th>Контрагент</th>
        <th>Организация</th>
        <th>Соглашение</th>
        <th>Операции</th>
      </tr>
      <tr v-for="(document, key) in documents" :key="key" class="table-row">
        <td>{{ document.ID }}</td>
        <td>{{ document.CREATE }}</td>
        <td>{{ document.NAME }}</td>
        <td>
          <div
            v-for="(name, keySer) in document.SERVICES_NAMES"
            :key="keySer + '_s'"
          >
            {{ name }}
          </div>
        </td>
        <td>{{ document.USER_NAME }}</td>
        <td>{{ document.COMPANY_NAME }}</td>
        <td>{{ document.AGREEMENT }}</td>
        <td>
          <popup-button button-text="Добавить собственность">
            <add-ownership v-bind:plot="id" v-bind:contract="document" v-on:ownership-add="getPlotData"></add-ownership>
          </popup-button></td>
      </tr>
    </table>
  </div>
</template>

<script>
import config from "@/config";
import AddDocument from "../add/Document";
import AddAgreement from "../add/Agreement";
import AddOwnership from "../add/Ownership";

export default {
  name: "TabDocuments",
  components: {AddDocument, AddAgreement, AddOwnership},
  data() {
    return {
      id: this.$route.params.id,
      url: config.backend_url,
      documents: [],
      contracts: []
    };
  },
  computed: {},
  watch: {},
  methods: {
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-documents/",
          data: { ID: this.id },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            this.documents = data;
          }
        });
    },
    getContracts: function() {
      let data = {
        url: this.url + "agreementtypelist/get/",
        data: {},
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(response => {
        let data = response.data;
        if (!data.error) {
          this.contracts = data;
        }
      });
    }
  },
  created() {
    this.getPlotData();
  }
};
</script>
